import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useNoIndex } from './hooks/useSEO';
import { useTranslation } from './i18n';

const NotFoundPage: React.FC = () => {
  const { t } = useTranslation();
    useNoIndex('Page Not Found | HipoTech');
    const navigate  = useNavigate();
    const location  = useLocation();

    return (
        <div style={{
            display:         'flex',
            alignItems:      'center',
            justifyContent:  'center',
            minHeight:       '100vh',
            fontFamily:      'system-ui, -apple-system, sans-serif',
            backgroundColor: '#f8fafc',
        }}>
            <div style={{
                textAlign:  'center',
                padding:    '48px 32px',
                maxWidth:   '480px',
            }}>
                <div style={{ fontSize: '72px', marginBottom: '16px', lineHeight: 1 }}>
                    404
                </div>
                <h1 style={{
                    fontSize:     '24px',
                    fontWeight:   700,
                    color:        '#0f172a',
                    marginBottom: '8px',
                }}>
                    {t('common.hardcoded.pageNotFound') || 'Page not found'}
                </h1>
                <p style={{
                    fontSize:     '15px',
                    color:        '#64748b',
                    marginBottom: '8px',
                }}>
                    The page at{' '}
                    <code style={{
                        backgroundColor: '#f1f5f9',
                        padding:         '1px 6px',
                        borderRadius:    '4px',
                        fontFamily:      'monospace',
                        fontSize:        '13px',
                        color:           '#374151',
                    }}>
                        {location.pathname}
                    </code>{' '}
                    does not exist.
                </p>
                <p style={{
                    fontSize:     '14px',
                    color:        '#94a3b8',
                    marginBottom: '32px',
                }}>
                    {t('common.hardcoded.itMayHaveBeenMoved') || 'It may have been moved, deleted, or you may have mistyped the address.'}
                </p>
                <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
                    <button
                        onClick={() => navigate(-1)}
                        style={{
                            padding:         '10px 20px',
                            fontSize:        '14px',
                            fontWeight:      500,
                            cursor:          'pointer',
                            borderRadius:    '6px',
                            border:          '1px solid #e2e8f0',
                            backgroundColor: '#ffffff',
                            color:           '#374151',
                        }}
                    >
                        ← Go back
                    </button>
                    <button
                        onClick={() => navigate('/')}
                        style={{
                            padding:         '10px 20px',
                            fontSize:        '14px',
                            fontWeight:      500,
                            cursor:          'pointer',
                            borderRadius:    '6px',
                            border:          'none',
                            backgroundColor: '#0f172a',
                            color:           '#ffffff',
                        }}
                    >
                        {t('common.hardcoded.goToHome') || 'Go to home'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default NotFoundPage;